/// <amd-module name="Wit/WorkItemLinksRegistration/ArtifactCache" />
import { ILinkIdentifier, IResolvedLinkDisplayData } from "./Contracts";
import { isPlaceholderForUnresolvedLinkIdentifier } from "./LinkUtils";

let instance: ArtifactCache | undefined = undefined;

/**
 * This is a deliberately simple cache that will only live as long as the browser session.
 */
export class ArtifactCache {
    private displayDataByKey = new Map<string, IResolvedLinkDisplayData>();

    public static getInstance(): ArtifactCache {
        if (!instance) {
            instance = new ArtifactCache();
        }
        return instance;
    }

    public get(linkIdentifier: ILinkIdentifier): IResolvedLinkDisplayData | undefined {
        const key = this.constructCacheKey(linkIdentifier);
        return this.displayDataByKey.get(key);
    }

    public set(linkIdentifier: ILinkIdentifier, displayData: IResolvedLinkDisplayData) {
        if (isPlaceholderForUnresolvedLinkIdentifier(displayData)) {
            return;
        }
        const key = this.constructCacheKey(linkIdentifier);
        this.displayDataByKey.set(key, displayData);
    }

    public clear(linkIdentifier: ILinkIdentifier) {
        const key = this.constructCacheKey(linkIdentifier);
        this.displayDataByKey.delete(key);
    }

    /**
     * This key includes any field values which should cause us to recognize two
     * links as distinct. Because we include the LastWriteDate and Comment, we
     * will reload artifacts that have changed either on the server or on the
     * current page.
     */
    private constructCacheKey(linkIdentifier: ILinkIdentifier): string {
        // prettier-ignore
        return `tool:${
            linkIdentifier.tool
        }, ID:${
            linkIdentifier.ID ?? "None"
        }, ExtID:${
            linkIdentifier.ExtID
        }, field:${
            linkIdentifier.FldID
        }, linkType:${
            linkIdentifier.LinkType ?? "None"
        }, originalName:${
            linkIdentifier.OriginalName ?? "None"
        }, filePath:${
            linkIdentifier.FilePath ?? "None"
        }, updateDate:${
            linkIdentifier.LastWriteDate ?? "None"
        }, comment:${
            linkIdentifier.Comment ?? "None"
        }`;
    }
}
